var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAccounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "64B099FD-4B42-4E0A-9F17-06423AA8D886") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Kit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(-168, -136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-accounts",
    transform: "translate(168, 136)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,18 L18,18 C18.5522847,18 19,18.4477153 19,19 C19,19.5522847 18.5522847,20 18,20 L6,20 C5.44771525,20 5,19.5522847 5,19 C5,18.4477153 5.44771525,18 6,18 Z M12,11 C11.4477153,11 11,11.4477153 11,12 L11,16 C11,16.5522847 11.4477153,17 12,17 C12.5522847,17 13,16.5522847 13,16 L13,12 C13,11.4477153 12.5522847,11 12,11 Z M16,11 C15.4477153,11 15,11.4477153 15,12 L15,16 C15,16.5522847 15.4477153,17 16,17 C16.5522847,17 17,16.5522847 17,16 L17,12 C17,11.4477153 16.5522847,11 16,11 Z M8,11 C7.44771525,11 7,11.4477153 7,12 L7,16 C7,16.5522847 7.44771525,17 8,17 C8.55228475,17 9,16.5522847 9,16 L9,12 C9,11.4477153 8.55228475,11 8,11 Z M12.5144958,4.30869745 L18.9041785,8.14250707 C19.3777587,8.42665523 19.5313238,9.04091549 19.2471756,9.51449576 C19.0664524,9.81570117 18.7409456,10 18.3896827,10 L5.6103173,10 C5.05803255,10 4.6103173,9.55228475 4.6103173,9 C4.6103173,8.64873715 4.79461613,8.32323032 5.09582154,8.14250707 L11.4855042,4.30869745 C11.8021866,4.11868802 12.1978134,4.11868802 12.5144958,4.30869745 Z",
    id: "Shape",
    fill: "#7A858E"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccounts);
export default __webpack_public_path__ + "static/media/icon-accounts.b81649303514a056a8ad31c6de1b8b2f.svg";
export { ForwardRef as ReactComponent };